import api, { okOrThrow } from "../../../../../services/api";
import {
  CreateRequest,
  ListQuery,
  PagedResponse,
  SiteKeyResponse,
  SiteKeySummary,
  Status,
  StatusRequest,
  UpdateRequest,
} from "../types/siteKey";

const normalizeSiteKey = (value?: string | null) => (value ?? "").trim().toUpperCase();

const normalizeCreateRequest = (body: CreateRequest): CreateRequest => ({
  ...body,
  siteKey: normalizeSiteKey(body.siteKey),
});


// 사이트키 목록 조회 API 요청
export const fetchSiteKeyList = async (
    query: ListQuery
    ): Promise<PagedResponse<SiteKeySummary>> => {
    const params = {
        keyword: query.keyword || "",
        planCode: query.planCode || "",
        status: query.status || "",
        page: query.page || 0,
        size: query.size || 10,
        sort: query.sort || "regDate,desc",
    };
    return okOrThrow(
        api.get<PagedResponse<SiteKeySummary>>("/admin/ai/site-keys", { params })
    );
}

export async function fetchLinkedSiteKeys(widgetConfigId: number) {
  const { data } = await api.get('/admin/ai/site-keys/linked', { params: { widgetConfigId }});
  return data as SiteKeySummary[];
}

// 사이트키 상세 조회 API 요청
export const fetchSiteKeyDetail = async (
    id: number
    ): Promise<SiteKeyResponse> => {
    return okOrThrow(api.get<SiteKeyResponse>(`/admin/ai/site-keys/${id}`));
}

// 사이트키 생성 API 요청
export const createSiteKey = (body: CreateRequest, actorId: string | number) =>
  okOrThrow<SiteKeyResponse>(
    api.post("/admin/ai/site-keys", normalizeCreateRequest(body), { params: { actor: String(actorId) } })
);

// 사이트키 수정 API 요청
export const updateSiteKey = (id: number, body: UpdateRequest, actorId: string | number) =>
  okOrThrow<SiteKeyResponse>(
    api.patch(`/admin/ai/site-keys/${id}`, body, { params: { actor: String(actorId) } })
);

// 사이트키 상태 변경 API 요청
export const changeSiteKeyStatus = (id: number, status: Status, notes: string | undefined, actorId: string | number) =>
  okOrThrow<SiteKeyResponse>(
    api.patch(`/admin/ai/site-keys/${id}/status`, { status, notes } as StatusRequest, {
      params: { actor: String(actorId) }
    })
  );

// 사이트키 사용여부 변경 API 요청
export const updateSiteKeyUseTf = (id: number, newUseTf: "Y" | "N", actorId: string | number) => {
  return okOrThrow<number>(
    api.patch(`/admin/ai/site-keys/${id}/use-tf`, null, {
      params: { newUseTf, actor: String(actorId) },
    })
  )
};

// 사이트키 삭제 API 요청
export const deleteSiteKey = (id: number, actorId: string | number) => {
  return okOrThrow<number>(
    api.patch(`/admin/ai/site-keys/${id}/del-tf`, null, {
      params: { actor: String(actorId) },
    })
  )
};

// (선택) 사이트키 검증 API 요청 - verify는 actor 안 받으면 기존대로
export const verifySiteKey = (siteKey: string, clientDomain: string) =>
  okOrThrow<{ ok: boolean; status: Status }>(
    api.post(`/admin/ai/site-keys/verify`, { siteKey: normalizeSiteKey(siteKey), clientDomain })
);
